/**
 * Lookup Service
 * @author PBirudukota
 * @description Used to fetch the look up values
 */
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private http: HttpClient) {
  }

  /**
   * Lookup - Business Types, Counties and States
   * @param type Lookup Type
   * @param appendFips Append FIPS Code with @ delimiter
   * @param country Country
   * @param state State
   * @param orgId Org Id
   */
  public lookup(type, appendFips?, country?, state?, orgId?): Observable<any> {

    let params = new HttpParams().set('TYPE', type);

    switch (type) {
      case 'STATES':
        params = params.append('COUNTRY', country);
        break;
      case 'COUNTIES':
        params = params.append('STATE', state);
        break;
      case 'BUSINESS_TYPES':
        params = params.append('ORG_ID', orgId);
        break;
    }

    if (appendFips) {params = params.append('APPEND_FIPS', appendFips);}

    return this.http.get(`/api/lookup`, {params});

  }

}
